import React, { Component } from 'react';
import MaterialIcon from 'material-icons-react';
import ShareRoomPopup from './ShareRoomPopup.js';
import './ShareRoom.css';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roomNameURL: 'http://estimato.io/' + this.props.roomName,
      showShareRoomPopup: false
    }

    this.toggleShareRoomPopup = this.toggleShareRoomPopup.bind(this);
  }

  toggleShareRoomPopup() {
    this.setState({ showShareRoomPopup: !this.state.showShareRoomPopup });
  }

  render() {
    return (
      <div className="share-room-area">
        <div className="share-room" onClick={this.toggleShareRoomPopup}>
          <div className="room-name">{this.props.roomName}</div>
          <div className="share-room-button">
            <MaterialIcon icon="link" />
          </div>
        </div>

        <ShareRoomPopup
          show={this.state.showShareRoomPopup}
          roomNameURL={this.state.roomNameURL}
          toggleShareRoomPopup={this.toggleShareRoomPopup} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Room/ShareRoom.js